import { useQuery, useMutation, useQueryClient } from 'react-query'
import { api } from '../services/api'
import { format } from 'date-fns'
import { useState } from 'react'
import { useToast } from '@chakra-ui/react'

const fetchProducao360 = async ({ pedido, pendente, compre_ganhe }) => {
  const response = await api.get('https://api.innovationbrindes.com.br/api/site/v2/fluxo-layout/listar-ilustracoes-pendentes', {
    params: {
      numero_pedido: pedido,
      pendente,
      compre_ganhe,
    },
  })

  if (response.status !== 200) {
    throw new Error('Erro ao buscar os dados')
  }

  const lista = response.data.dados.map((item) => ({
    ...item,
    id: item.id,
    numeroNota: item.numero_nota,
    pedido: item.numero_pedido,
    itensPorLayout: `${item.qtd_ilustracao}/${item.total_produto}`,
    nome: item.nome_produto,
    nomeIlustracao: item.nome_ilustracao,
    linkArte: item.link_ilustracao,
    layout: item.layout_caricatura,
    dataInicio: item.data_producao_inicio ? format(new Date(item.data_producao_inicio), 'dd/MM/yyyy') : '',
    horaInicio: item.data_producao_inicio ? format(new Date(item.data_producao_inicio), 'HH:mm') : '',
    dataHoraTermino: item.data_producao_fim,
    dataHoraInicio: item.data_producao_inicio,
    dataTermino: item.data_producao_fim ? format(new Date(item.data_producao_fim), 'dd/MM/yyyy') : '',
    horaTermino: item.data_producao_fim ? format(new Date(item.data_producao_fim), 'HH:mm') : '',
    personalizacao: item.personalizacao,
    usuarioInicio: item.usuario_inicio,
    usuarioTermimo: item.usuario_fim,
  }))

  return {
    lista,
    quantidade_itens: response.data.quantidade_itens,
    total_pendentes: response.data.total_pendentes,
  }
}

const updateProducao360 = async ({ numero_nota, coluna, usuario, codigo_produto, id_solicitacao }) => {
  const response = await api.put(`/site/v2/fluxo-layout/atualiza-status-ilustracoes`, {
    numero_nota,
    coluna,
    usuario,
    codigo_produto,
    id_solicitacao,
  })

  if (response.status !== 200) {
    throw new Error('Erro ao atualizar os dados')
  }

  return response.data
}

export const useProducao360 = () => {
  const queryClient = useQueryClient()
  const toast = useToast({
    position: 'top-right',
    duration: 2000,
    isClosable: true,
  })

  const [formValues, setFormValues] = useState({
    pedido: '',
    pendente: '',
    compre_ganhe: null,
  })

  const query = useQuery({
    queryKey: ['producao360', formValues],
    queryFn: () => fetchProducao360(formValues),
    refetchOnWindowFocus: false,
    enabled: !!formValues.pedido || !!formValues.compre_ganhe,
    onError: (data) => {
      toast({
        title: 'Erro',
        description: data?.response?.data?.erros,
        status: 'error',
      })
    },
  })

  const mutation = useMutation({
    mutationFn: updateProducao360,
    onSuccess: () => {
      queryClient.invalidateQueries('producao360')
    },
    onError: (error) => {
      toast({
        title: 'Erro',
        description: error?.response?.data?.erros,
        status: 'error',
      })
    },
  })

  return { query, mutation, setFormValues }
}
